import React from "react";

import image from "../../assets/jpg/no_image.jpg";
import { IAnimal } from "../../modules/animals/interface";
import { useTranslate } from "../../hooks/useTranslate";
import {
  Avatar,
  Checkbox,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

interface IAnimalItem {
  animal: IAnimal;
  checked: boolean;
  onCheckChange?: (animalId: string, checked: boolean) => void;
}

export const AnimalItem: React.FC<IAnimalItem> = ({
  animal,
  checked,
  onCheckChange,
}) => {
  const { translate } = useTranslate();

  return (
    <>
      <Paper
        key={animal.id}
        sx={{
          p: 1,
          bgcolor: "grey.50",
        }}
        elevation={0}
      >
        <Grid container spacing={2}>
          <Grid item md={false}>
            <Avatar src={animal?.photo ?? image} alt={animal.name} />
          </Grid>
          <Grid item md>
            <Stack>
              <Typography>
                #{animal.number_identifier} <strong>{animal.name}</strong>
              </Typography>
              <Typography variant="caption">
                {`${translate("animals.placeholder_batch")}: ${
                  animal.batch?.name ?? translate("global.uninformed")
                } / ${translate("animals.placeholder_flock")}: ${
                  animal.flock?.name ?? translate("global.uninformed")
                }`}
              </Typography>
            </Stack>
          </Grid>
          <Grid item md={false}>
            <Checkbox
              checked={checked}
              onChange={(_, checked) => {
                onCheckChange?.(animal.id, checked);
              }}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
